<body>
            <div class="container-fluid" [ngClass]="{'dark-bg' : isDark }">
              <div class="row">
                <div class="col-12">                
                  <div class="invoice p-3 mb-3"> 

                    <div class="row justify-content-center">
                        <h6>Inventory Balance Report</h6> 
                    </div>
      
                    <!-- Table row -->
                    <div class="row">
                    <div class="col-12">
                    <div class="card" [ngClass]="{'dark-bg' : isDark ,'dark-border-color' : isDark }">                  
                     <div class="card-body">

                       <div class="row pb-2">
                        <div class="col-5">
                          <div class="input-group">
                              <span class="input-group-prepend">
                                  <div class="input-group-text bg-transparent border-right-0"><i class="fa fa-search" [ngClass]="{'dark-bg' : isDark }"></i></div>
                              </span>
                              <input [(ngModel)]="searchKey" (keyup)="applyFilter()" autocomplete="off" [ngClass]="{'dark-bg' : isDark }" class="form-control py-2 border-left-0  border-right-0 border" type="text" placeholder="Search by Item">
                              <span class="input-group-append">
                                <button class="btn  border-left-0 border" type="button">
                                    <i *ngIf="searchKey" (click)="onSearchClear()" class="fa fa-close" [ngClass]="{'dark-bg' : isDark }"></i>
                                </button>
                              </span>            
                          </div>     
                        </div>
                        <!-- <div class="col-3 input-group">
                          <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text" [ngClass]="{'dark-bg' : isDark }"><i class="fa fa-calendar-o"></i></span>
                              </div>
                              <input type="text" [ngClass]="{'dark-bg' : isDark }" [(ngModel)]="toDate" bsDatepicker [bsConfig]="datepickerConfig" class="form-control" placeholder="To Date">
                            </div>
                      </div> -->
                        <div class="col-4 input-group">
                            <select class="custom-select"  [(ngModel)]="category"  [ngClass]="{'dark-bg' : isDark }" (change)="applyFilterCategory($event.target)" id="inputGroupSelect02">
                                <option selected [ngValue]="null">All Category</option>
                                <option *ngFor="let item of categoryList" [value]="item.ItemCategory"> {{item.ItemCategory}}</option> 
                              </select>
                          </div>
                          <div class="col-3 input-group">
                            <!-- <button (click)="viewBtnClicked()" mat-raised-button>View</button> -->
                            <button (click)="clearBtnClicked()" mat-raised-button class="ml-2">Clear</button>                         
                          </div>
                       </div>

                      <div class="col-12 table-responsive scrollable" id="inventoryBalReport">
                        <table class="table" [ngClass]="{'dark-bg' : isDark }">
                          <thead>
                          <tr >                          
                            <th>ItemCode</th>
                            <th>Description</th>  
                            <th>Category</th>    
                            <th class="text-right">ROL</th>                
                            <th class="text-right">QtyBal</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr *ngFor="let item of filteredItemList">    
                            <td>{{item.ItemCode}}</td>
                            <td>{{item.Description}}</td>   
                            <td>{{item.Category}}</td>    
                            <td class="text-right">{{item.ReorderLevel}}</td>                          
                            <td class="text-right">{{item.QtyBal}}</td>     
                          </tr>                                              
                          </tbody>
                        </table>
                      </div>
                      <!-- /.col -->
                     </div>
                    </div>
                    </div>
                    </div>
                    <!-- /.row -->
      
      
                    <!-- this row will not appear when printing -->
                    <div class="row no-print">
                      <div class="col-12">
                        <button [ngClass]="{'dark-bg' : isDark }" type="button" (click)="savePDF('print')"  class="btn btn-default float-right"><i class="fas fa-print"></i> Print</button>      
                        <button [ngClass]="{'dark-bg' : isDark }" type="button" (click)="exportexcel()"  class="btn btn-default float-right"><i class="fa fa-file-excel-o" style="color:green"></i> Excel</button>      
                         <button [ngClass]="{'dark-bg' : isDark }" type="button" (click)="savePDF('open')"  class="btn btn-default float-right"><i class="fa fa-file-pdf-o" style="color:red"></i> PDF</button>                                                                                                                                                              
                      </div>
                    </div>


                  </div><!-- /.invoice -->                 
                </div><!-- /.col -->
              </div><!-- /.row -->
            </div><!-- /.container-fluid -->       
 </body>




